import React, { useEffect, useState, useRef } from 'react';
import * as Styles from './styles';
import { calculateInnerElements } from '../../utils/calculateInnerElements';
import { getInnerElementsSizes } from '../../utils/getInnerElementsSizes';
export const Labels = _ref => {
  let {
    children,
    width
  } = _ref;
  const [loading, setLoading] = useState(true);
  const labelGroupRef = useRef(null);
  const [numberOfVisibleLabels, setNumberOfVisibleLabels] = useState((children === null || children === void 0 ? void 0 : children.length) || 0);
  const [labelsSizes, setLabelsSizes] = useState([]);
  const visibleLabels = numberOfVisibleLabels - 1;
  useEffect(() => {
    setNumberOfVisibleLabels(calculateInnerElements(labelsSizes, labelGroupRef));
  }, [labelsSizes, width]);
  useEffect(() => {
    var _a;
    (_a = document === null || document === void 0 ? void 0 : document.fonts) === null || _a === void 0 ? void 0 : _a.ready.then(() => {
      setLoading(false);
      setLabelsSizes(getInnerElementsSizes(labelGroupRef));
    });
  }, []);
  if (!children) {
    return React.createElement("div", {
      style: {
        height: '18px'
      }
    });
  }
  return React.createElement(Styles.LabelGroup, {
    className: loading ? 'loading' : '',
    ref: labelGroupRef,
    "data-testid": "labelGroup"
  }, children.map((label, idx) => {
    return React.createElement(Styles.LabelItem, {
      key: (label === null || label === void 0 ? void 0 : label.key) || idx,
      isVisible: idx <= visibleLabels
    }, label);
  }));
};